export enum CouponValueType {
    Amount = 1,
    Percentage = 2
}